import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { selectAccessToken } from '../slices/staffSlice';
import { fetchRequests } from '../Requests/getRequests';
import { show } from '../slices/toastSlice';
import { authStaff } from '../utils/constants';
import { useNavigate } from 'react-router-dom';

// Fetches all mandates for a given customer phone (format: 233XXXXXXXXX)
function useNpontuCustomerMandates({ phone }) {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const accessToken = useSelector(selectAccessToken);
    const [isLoading, setIsLoading] = useState(true);
    const [customerMandates, setCustomerMandates] = useState([]);

    const formattedPhone = phone?.startsWith('0') ? `233${phone.slice(1)}` : phone;

    useEffect(() => {
        if (!formattedPhone) return;

        let unsubscribed = false;

        const getCustomerMandates = async() => {
            setIsLoading(true);

            let headers = authStaff(accessToken);
            let url = `/payments/npontu/customer/mandates`;
            let params = { phone: formattedPhone };

            let res = await fetchRequests(url, "GET", headers, params, {});
            setIsLoading(false);

            if(res?.code === 401){
                sessionStorage.clear();
                navigate("/login");
                dispatch(show({
                    type : "error",
                    state : true,
                    message : "Your session has expired. Please login to continue."
                }));
                return;
            }

            if(res?.err){
                dispatch(show({
                    type : "error",
                    state : true,
                    message : res?.err
                }));
                return;
            }

            if(!unsubscribed){
                setCustomerMandates(res?.data?.data ?? []);
            }
        }

        getCustomerMandates();

        return () => {
            unsubscribed = true;
        }
    }, [dispatch, navigate, accessToken, formattedPhone])

    return { isLoading, customerMandates }
}

export default useNpontuCustomerMandates
